/**
 * 提醒弹窗队列 (Zustand)
 * - 收到 WS reminder 消息 → push 进队列
 * - ReminderDialog 监听队列, 一次显示一条
 * - 用户操作 (完成/推迟/关闭) → remove
 */

import { create } from 'zustand';

export type ReminderKind = 'reminder' | 'due_date';
export type ReminderUrgency = 'normal' | 'strong';

export interface ReminderItem {
  /** 唯一 id (前端生成, 用于同一条 task 不重复弹) */
  id: string;
  task_id: string;
  title: string;
  body?: string;
  kind: ReminderKind;
  urgency: ReminderUrgency;
  /** 收到时的时间戳 */
  receivedAt: number;
}

interface ReminderStore {
  items: ReminderItem[];
  push: (item: ReminderItem) => void;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useReminderStore = create<ReminderStore>((set) => ({
  items: [],
  push: (item) =>
    set((s) => {
      // 同 task_id 已存在时不重复 push (防止 WS 重连 + 后端重复触发)
      if (s.items.some((x) => x.task_id === item.task_id && x.kind === item.kind)) {
        return s;
      }
      return { items: [...s.items, item] };
    }),
  dismiss: (id) =>
    set((s) => ({ items: s.items.filter((x) => x.id !== id) })),
  clear: () => set({ items: [] }),
}));